<template>
  <div>
    <CommentForm class="form" v-model="comment" @confirm="submitComment" @login="$emit('login')" />
    <EmptyBanner v-if="list.length===0" :label="$t('bounty.messageEmpty')" />
    <CommentItem
      v-for="item in list"
      :key="item.id"
      :target="item"
    />
    <NouPagerLight
      v-if="total>0"
      class="g-bottom-pager"
      v-model="currentPage"
      :total="total"
      :size="CONFIG.pageSizeSm"
      @change="fetchList"
    />
  </div>
</template>

<script>

import URLS from '@/config/url';
import { CONFIG } from '@/config/enum';
import CommentItem from '@/views/Bounty/CommentItem.vue';
import CommentForm from '@/components/CommentForm.vue';
import EmptyBanner from '@/components/EmptyBanner.vue';

export default {
  name: 'MessageList',
  components: {
    EmptyBanner,
    CommentForm,
    CommentItem,
  },
  data() {
    return {
      comment: '',
      list: [],
      total: 0,
      currentPage: 1,
      CONFIG,
      bountyId: Number(this.$route.query.id),
    };
  },
  methods: {
    refresh() {
      this.currentPage = 1;
      this.fetchList();
    },
    fetchList() {
      this.$request({
        url: URLS.commentsList,
        method: 'post',
        data: {
          id: this.bountyId,
          page_size: CONFIG.pageSizeSm,
          page_number: this.currentPage,
        },
      }).then(({ result }) => {
        this.total = result.total;
        this.list = result.list;
      });
    },
    submitComment(val) {
      this.$request({
        url: URLS.replyBounty,
        method: 'post',
        data: {
          ontid: this.$store.state.id,
          refer_id: this.bountyId,
          content: val,
        },
      }).then(() => {
        this.comment = '';
        this.refresh();
      });
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';
  .btn--login {
    display: block;
    margin: 0 auto $padding-sm;
  }

  .form {
    margin-bottom: $padding-sm;
  }
</style>
